import { footerCols } from "@/mocks/heiliaoHome";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100/60 border-t border-background-200/70">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-8 md:gap-6">
          {/* 品牌 */}
          <div className="md:col-span-2">
            <a href="#" onClick={(e) => e.preventDefault()} className="flex items-center gap-2.5 cursor-pointer">
              <span className="grid place-items-center h-9 w-9 rounded-lg bg-primary-500 text-background-50">
                <i className="ri-skull-2-fill text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-serif text-lg font-black text-foreground-950 whitespace-nowrap">1黑料网</span>
                <span className="text-[10px] text-foreground-500 tracking-widest mt-0.5">导航 · 入口 · 直达</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 max-w-xs">
              1黑料网 社区讨论首页，提供 1黑料网导航、最新地址与直达入口，也聚集了一批爱聊天的吃瓜老友。
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
              <span className="inline-flex items-center gap-1"><i className="ri-fire-fill text-primary-500"></i> 今日热瓜 6</span>
              <span className="h-3 w-px bg-background-300"></span>
              <span className="inline-flex items-center gap-1"><i className="ri-user-heart-line text-accent-600"></i> 12.4w 瓜友在线</span>
              <span className="h-3 w-px bg-background-300"></span>
              <span className="inline-flex items-center gap-1"><i className="ri-checkbox-circle-line text-secondary-600"></i> 入口正常</span>
            </div>
          </div>

          {/* 链接列 */}
          {footerCols.map((col) => (
            <div key={col.title} className="md:col-span-1">
              <h4 className="font-serif text-sm font-bold text-foreground-950 mb-3">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      onClick={(e) => e.preventDefault()}
                      className="text-[13px] text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 社区公约提示条 */}
        <div className="mt-10 flex flex-col gap-2 rounded-lg bg-background-50/70 border border-background-200/60 px-4 py-3.5">
          <p className="flex items-start gap-2 text-xs leading-relaxed text-foreground-600">
            <i className="ri-shield-check-line text-primary-600 shrink-0 mt-0.5"></i>
            <span>
              理性吃瓜公约：爆料需讲证据，评论对事不对人，不传播未经核实的私人信息，尊重当事人隐私与人格。造谣、引战、刷屏一律不受欢迎。
            </span>
          </p>
          <p className="flex items-start gap-2 text-xs leading-relaxed text-foreground-500">
            <i className="ri-map-pin-2-line text-accent-600 shrink-0 mt-0.5"></i>
            <span>
              找不到入口？1黑料网 最新地址会先在导航栏与「找地址」专区更新，收藏本页即可一键直达首页，不错过任何内容。
            </span>
          </p>
        </div>
      </div>

      {/* 底部版权条 */}
      <div className="border-t border-background-200/70">
        <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <span>© 2026 1黑料网 · 社区讨论与娱乐信息导航站点</span>
          <span className="flex items-center gap-3 whitespace-nowrap">
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-primary-700 cursor-pointer">发言规则</a>
            <span className="h-3 w-px bg-background-300"></span>
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-primary-700 cursor-pointer">理性讨论倡议</a>
            <span className="h-3 w-px bg-background-300"></span>
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-primary-700 cursor-pointer">联系我们</a>
          </span>
        </div>
      </div>
    </footer>
  );
}